import Navbar from "./Navbar";
import Spinner from "./Spinner";
import { Helmet } from "react-helmet";


const Layout = ({ children, title, loading }) => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />



                <title>{title || "Home"} | Store </title>
                <meta
                    name="description"
                    content="E-commerce store built with React, Node, Express and Postgres"
                />
                <meta
                    name="robots"
                    content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
                />

                <link rel="" href="" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Store" />
                <meta
                    property="og:description"
                    content="React, Node, Express and Postgres"
                />
                <meta property="og:url" content="" />
                <meta property="og:site_name" content="Store" />
                <meta property="og:image" content="abc.png" />
                <meta property="og:image:secure_url" content="abc.png" />
                <meta name="abc:card" content="summary_large_image" />
                <meta name="abc:site" content="" />
                <meta name="abc:creator" content="" />
                <meta
                    name="twitter:description"
                    content="React, Node, Express and Postgres"
                />
                <meta name="twitter:title" content="Store" />
                <meta name="twitter:image" content="android-chrome-512x512.png" />

                <style type="text/css">{`
        html,body{
          height: 100%;
        }
    `}</style>
            </Helmet>
            <div class="content">
                <Navbar />
                <div className="flex-grow h-full w-full">
                    {loading ? (
                        <Spinner size={100} loading />
                    ) : (
                        <div className="text-gray-700 mt-16 mx-auto px-2 lg:px-56 h-full w-full">
                            <main className="h-full">{children}</main>
                        </div>
                    )}
                </div>

            </div>


        </>
    );
};

export default Layout;


